import React from 'react';
import { Typography } from '@mui/material';

/**
 * Patient name template
 */
export const PatientTemplate: React.FC<{ firstName?: string; lastName?: string }> = ({
  firstName,
  lastName,
}) => {
  const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  return (
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {fullName || '-'}
    </Typography>
  );
};

export default PatientTemplate;
